import React from 'react';
import { Flex, HorizontalLine, Paragraph } from '../../../globals/appGlobal';
import { Link } from 'react-router-dom';
import { Social } from '../desktop-footer/desktopFooterStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import {
	faFacebookF,
	faInstagram,
	faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { PhoneFooterWrapper } from './phoneFooterStyles';

const PhoneFooter = () => {
	const date = new Date();
	const year = date.getFullYear();

	return (
		<PhoneFooterWrapper>
			<HorizontalLine />
			<div>
				<Link to='/about'>
					<Paragraph>About edanra</Paragraph>
				</Link>
				<Link to='/edanra-nss'>
					<Paragraph>edanra nss</Paragraph>
				</Link>
				<Link to='/terms'>
					<Paragraph>Privacy & terms</Paragraph>
				</Link>
			</div>
			<HorizontalLine />
			<Flex spaceBetween>
				<Paragraph>©{year} edanra</Paragraph>
				<Social>
					<a href='tel:0553220405' target='_blank' rel='noreferrer'>
						<FontAwesomeIcon icon={faPhoneAlt} />
					</a>
					<a
						href='mailto:yourfriends@edanra.com'
						target='_blank'
						rel='noreferrer'
					>
						<FontAwesomeIcon icon={faEnvelope} />
					</a>
					<a
						href='https://web.facebook.com/lifeatedanra'
						target='_blank'
						rel='noreferrer'
					>
						<FontAwesomeIcon icon={faFacebookF} />
					</a>
					<a
						href='https://twitter.com/lifeatedanra'
						target='_blank'
						rel='noreferrer'
					>
						<FontAwesomeIcon icon={faTwitter} />
					</a>
					<a
						href='https://www.instagram.com/lifeatedanra'
						target='_blank'
						rel='noreferrer'
					>
						<FontAwesomeIcon icon={faInstagram} />
					</a>
				</Social>
			</Flex>
		</PhoneFooterWrapper>
	);
};

export default PhoneFooter;
